// src/main.tsx
// Auto-generated by corebuilder. Edit freely.

import React from 'react';
import ReactDOM from 'react-dom/client';
import { StoreProvider } from '@react/providers';
import App from './App';

// Import global styles
import '@core/ui/css/index.css';
import './index.css';

// Configuration from environment
const config = {
  apiBaseUrl: import.meta.env.VITE_API_URL || '/api/v1',
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE || 'en',
  scope: {
    platformId: import.meta.env.VITE_PLATFORM_ID || 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
    productId: import.meta.env.VITE_PRODUCT_ID || 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
    tenantId: import.meta.env.VITE_TENANT_ID || 'cccccccc-cccc-cccc-cccc-cccccccccccc',
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StoreProvider
      apiBaseUrl={config.apiBaseUrl}
      defaultLocale={config.defaultLocale}
      scope={config.scope}
      onError={(error) => {
        console.error('Failed to initialize application:', error);
      }}
    >
      <App />
    </StoreProvider>
  </React.StrictMode>
);
